import Constants from "../../const/Constants";
import {TreeDto} from "../../shared/types/api";

let CardImageUtils = {

    getCardImage(tree?: TreeDto) {
        if (tree) {
            const id = tree.id;
            const status = tree.status;
            return `${Constants.queryConst}/v1/trees/image/${id}/${status}`
        } else {
            const defaultTreeId = 1;
            return `${Constants.queryConst}/v1/trees/image/${defaultTreeId}/JUST_PLANTED`
        }
    },

    getCardWateredImage(tree?: TreeDto) {
        if (tree) {
            const id = tree.id;
            const status = 'WATERED';
            return `${Constants.queryConst}/v1/trees/image/${id}/${status}`
        } else {
            const defaultTreeId = 1;
            return `${Constants.queryConst}/v1/trees/image/${defaultTreeId}/WATERED`
        }
    }

}

export default CardImageUtils
